import AddStaffForm from "../components/AddStaffForm";

export default function AddStaffPage() {
  return <AddStaffForm />;
}
